// Captures the browser's `beforeinstallprompt` event as early as possible.
//
// That event can fire before React mounts and only fires once — if you miss it,
// there's no way to trigger the install UI later. So we register the listener at
// module-eval time (imported for its side effect in main.jsx) and stash the
// deferred event, then let the InstallPrompt component subscribe to it.

let deferredPrompt = null
const listeners = new Set()

function notify() {
  listeners.forEach((fn) => {
    try { fn(deferredPrompt) } catch { /* ignore listener errors */ }
  })
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Stop Chrome's default mini-infobar; we show our own banner instead.
    e.preventDefault()
    deferredPrompt = e
    notify()
  })
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null
    notify()
  })
}

export function getInstallPrompt() {
  return deferredPrompt
}

export function onInstallPromptChange(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function clearInstallPrompt() {
  deferredPrompt = null
}
